// extracted by mini-css-extract-plugin
export default {"cls1":"TXYvZxLEdCmqC0N6Scv3","cls2":"Ktm8F_eovqE5npgT59E_ TXYvZxLEdCmqC0N6Scv3"};